import { HashRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ConfigProvider, App as AntdApp } from "antd";
import { AuthProvider } from "./context/AuthContext";

// 运行时推导部署子目录路径，兼容任意子目录部署
const basename = import.meta.env.DEV
  ? __BASE_PATH__
  : new URL("..", import.meta.url).pathname.replace(/\/$/, "") || "/";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#830051",
            colorInfo: "#830051",
            colorSuccess: "#830051",
          },
          components: {
            Button: {
              colorPrimary: "#830051", // 主按钮背景
              colorPrimaryHover: "#a0006a", // hover 背景
              colorPrimaryActive: "#6a0042", // active/点击 背景
              defaultColor: "#830051", // 默认按钮文字色
              defaultBorderColor: "#830051", // 默认按钮边框色
              colorLink: "#830051", // link 按钮文字色
              colorLinkHover: "#a0006a",
              colorBorderDisabled: "#DAB2CA",
              colorBgContainerDisabled: "#DAB2CA",
              colorTextDisabled: "#fff",
            },
            Modal: {
              colorPrimary: "#830051",
            },
          },
        }}
      >
        <AntdApp message={{ maxCount: 3, top: "15vh" }}>
          <HashRouter>
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </HashRouter>
        </AntdApp>
      </ConfigProvider>
    </I18nextProvider>
  );
}

export default App;
